export var DEFAULT_VALUE = [0];